import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard } from '../../helpers/helpers'
import formatIntegerBySpace from '../../../../helpers/formatters/format-integer-by-space'
import { renderShipmentCalculated } from '../../helpers/render-shipment-calculated'

export const calculatedLabelAreaColumn: ShipmentColumn = {
    key: 'labelArea',
    dataIndex: ['calculated', 'labelArea'],
    title: 'Площадь этикетки',
    width: 80,
    onCell: onCellStandard,
    render: renderShipmentCalculated(calculated =>
        formatIntegerBySpace(calculated?.labelArea || 0)
    ),
}
